<template>
  <v-app id="app">
    <navigation-bar v-if="logged" />
    <v-app-bar
      style="-webkit-app-region: drag; -webkit-user-select: none; user-select: none"
      app
      fixed
      clipped-left
    >
      <v-app-bar-nav-icon
        style="-webkit-app-region: no-drag"
        @click.stop="toggleNavbar"
      />
      <v-toolbar-title>
        <img
          id="logo"
          src="../assets/logo.png"
        />
      </v-toolbar-title>
      <v-spacer />
      <span class="titlePage">
        {{ getTitle }}
      </span>
      <v-spacer />
      <v-menu
        v-if="logged"
        v-model="notif"
        offset-y
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            style="-webkit-app-region: no-drag"
            v-on="on"
          >
            <v-badge
              color="rgba(0, 0, 255, 0.0)"
              overlap
              offset-x="10px"
              offset-y="10px"
              :content="nbNotification"
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-list
          v-if="listPlayer.length != 0"
          :width="650"
        >
          <template v-for="(player, index) in listPlayer">
            <v-list-item :key="player.name">
              <v-list-item-avatar>
                <v-icon :color="player.nb_days < 0 ? 'red' : 'yellow'">mdi-alert-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >{{ player.name }}
                  <span class="colorID"> {{ " · " + player.identifier }} </span>
                </v-list-item-title>
                <v-list-item-subtitle v-if="player.nb_days > 0">
                  {{
                    $t("profile.sections.account.number-renewal") +
                    " " +
                    player.nb_days +
                    " " +
                    $t("notification.days") +
                    formatDate(player.dt_expire)
                  }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                  {{ $t("notification.expire") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <dialog-player-notif
                  icon="mdi-information"
                  :player="player"
                />
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < listPlayer.length - 1"
              :key="index"
            />
          </template>
        </v-list>
        <v-list v-else>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("notification.notification") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-if="logged"
        offset-y
        transition="slide-y-transition"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            style="-webkit-app-region: no-drag"
            v-on="on"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{ $store.state.user.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ $store.state.user.login }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="userPermission()"
            to="/profile/0"
          >
            <v-list-item-content>
              <v-list-item-title>{{ $t("profile.account") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item to="/changelog">
            <v-list-item-content>
              <v-list-item-title>{{ $t("navbar.changelog") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://app.dmcware.com/mediacenter/share/docs/DMCWare.pdf"
            target="blank"
          >
            <v-list-item-content>
              <v-list-item-title>{{ $t("navbar.documentation") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item @click="disconnect()">
            <v-list-item-content>
              <v-list-item-title>{{ $t("login.logout") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="electronRun"
        style="-webkit-app-region: no-drag"
        icon
        small
        class="mx-1"
        @click="minimize()"
      >
        <v-icon small>mdi-minus</v-icon>
      </v-btn>
      <v-btn
        v-if="electronRun"
        style="-webkit-app-region: no-drag"
        icon
        small
        class="mx-1"
        @click="maximize()"
      >
        <v-icon small>mdi-crop-square</v-icon>
      </v-btn>
      <v-btn
        v-if="electronRun"
        style="-webkit-app-region: no-drag"
        icon
        small
        class="mx-1 mr-0"
        @click="close()"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
    <bottom-navigation-bar v-if="logged" />
    <snackbar />
  </v-app>
</template>

<script>
// Components
import navigationBar from "@/components/Navigation/NavigationBar";
import bottomNavigationBar from "@/components/Navigation/BottomNavigationBar";
import dialogPlayerNotif from "@/components/Dialog/DialogPlayerNotif";
import snackbar from "@/components/Common/Snackbar.vue";

// Connectors
import { PlayerConnector } from "@/components/Database/PlayerConnector";

// Libs
const moment = require("moment");

export default {
  components: {
    navigationBar,
    bottomNavigationBar,
    dialogPlayerNotif,
    snackbar,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      appFunc: null,
      resolution: this.$store.state.config.system.resolution,
      position: this.$store.state.config.system.position,
      initTimeout: null,
      listPlayer: [],
      notif: false,
    };
  },
  computed: {
    electronRun: {
      get() {
        return this.isElectron();
      },
    },
    getTitle: {
      get() {
        return this.$store.state.navigationBar.headerName;
      },
    },
    logged: {
      get() {
        const isLogged = this.$store.state.user.userId != null;

        if (isLogged) {
          this.getNbDaysLicense();
        } else {
          this.disconnect();
        }

        return isLogged;
      },
    },
    nbNotification: {
      get() {
        if (this.listPlayer.length != 0) {
          return this.listPlayer.length;
        } else {
          return "";
        }
      },
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getNbDaysLicense() {
      this.playerConnector.getNbDaysLicense(this.$store.state.user.socId).then((response) => {
        this.listPlayer = response;

        if (this.listPlayer.length > 0) {
          this.notif = true;
        }
      });
    },
    disconnect() {
      this.$store.dispatch("disconnect").user;

      if (this.$router.history.current.fullPath != "/") {
        localStorage.disconnected = true;
        this.$router.push({ path: "/" });
      }
    },
    toggleNavbar() {
      this.$store.dispatch("toggleNavbar").config;
      localStorage.isMinimized = this.$store.state.config.prefs.isMinimized;
    },
    isElectron() {
      // Renderer process
      if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") {
        return true;
      }

      // Main process
      if (typeof process !== "undefined" && typeof process.versions === "object" && !!process.versions.electron) {
        return true;
      }

      // Detect the user agent when the "nodeIntegration" option is set to true
      if (navigator.userAgent.indexOf() !== undefined) {
        if (
          typeof navigator === "object" &&
          typeof navigator.userAgent === "string" &&
          navigator.userAgent.indexOf("Electron") >= 0
        ) {
          return true;
        }
      }

      return false;
    },
    maximize() {
      if (this.appFunc !== null) {
        let window = this.appFunc.getCurrentWindow();
        window.isMaximized() ? window.unmaximize() : window.maximize();
      }
    },
    minimize() {
      if (this.appFunc !== null) {
        this.appFunc.getCurrentWindow().minimize();
      }
    },
    close() {
      if (this.appFunc !== null) {
        this.appFunc.getCurrentWindow().close();
      }
    },
    closeScreensaver() {
      if (this.$store.state.config.system.screensaverMode) {
        this.close();
      }
    },
    userPermission() {
      if (this.$store.state.user.permissions != 0) {
        return true;
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Cocogoose";
  src: url("../assets/fonts/cocogoose.ttf");
}

.titlePage {
  font-size: 22px;
  font-family: "Cocogoose";
}

.v-item-group.v-bottom-navigation {
  left: calc(50% - 150px);
  bottom: 1px;
  width: 300px !important;
  border-radius: 2px 2px 0 0;
  z-index: 5;
}

#logo {
  height: 70px;
}

.colorID {
  color: rgba(240, 240, 240, 0.699);
}
</style>
